import { api } from '../core';
import { BUNDLE_TAGS, BUNDLE_SECTIONS_TAG } from '../constants';
import type { RootState } from '@/store';
import { refreshBundleSectionsWithCurrentFilters } from './getBundleSections';

export interface SlotIntoOriginalRecordsRequest {
  page_ids: string[];
  bundle_id: string;
}

export interface SlotIntoOriginalRecordsResponse {
  success: boolean;
}

const slotIntoOriginalRecordsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    slotIntoOriginalRecords: builder.mutation<SlotIntoOriginalRecordsResponse, SlotIntoOriginalRecordsRequest>({
      query: (body) => ({
        url: '/bundle/pages/slot-in',
        method: 'POST',
        body,
      }),
      async onQueryStarted(_arg, { dispatch, queryFulfilled, getState }) {
        try {
          await queryFulfilled;
          const state = getState() as RootState;
          // Refresh sections with current filters preserved (MER-429)
          refreshBundleSectionsWithCurrentFilters(dispatch, state);
          // Invalidate remaining bundle tags (excluding BUNDLE_SECTIONS_TAG which is handled above)
          dispatch(api.util.invalidateTags([...BUNDLE_TAGS].filter((tag) => tag !== BUNDLE_SECTIONS_TAG)));
        } catch (error) {
          console.error('Error in slotIntoOriginalRecords in onQueryStarted: ', error);
        }
      },
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useSlotIntoOriginalRecordsMutation } = slotIntoOriginalRecordsApi;
